import { type QueryClient } from '@tanstack/react-query';
import { type TaskInfoDto } from '@/app/models/TaskInfoDto';
import { taskKeys } from './_consts';
import { upsertTask } from './_utils';

type Task = TaskInfoDto<string>;

/** A lista é a verdade: consultada de novo a cada (re)conexão do stream e depois de iniciar uma tarefa. */
export const refreshMyTasks = (queryClient: QueryClient) => queryClient.invalidateQueries({ queryKey: taskKeys.mine });

/**
 * Evento SSE `task`: troca a tarefa no cache, sem nova consulta. Se havia uma consulta em voo, ela traz uma foto
 * mais velha que o evento e o desfaria (tarefa concluída voltando a "rodando"); invalidar cancela essa consulta
 * e pede uma nova, que já nasce depois do evento.
 */
export const applyTaskEvent = (queryClient: QueryClient, task: Task) => {
  const wasFetching = queryClient.isFetching({ queryKey: taskKeys.mine }) > 0;
  queryClient.setQueryData<Task[]>(taskKeys.mine, (tasks) => upsertTask(tasks, task));
  if (wasFetching) void refreshMyTasks(queryClient);
};

/**
 * Tarefa que este navegador acabou de iniciar: entra no cache como rodando para o sino reagir na hora e para o
 * aviso de conclusão ver a passagem de "rodando" a "pronta". Se o evento SSE chegou antes, vale o dele.
 */
export const addStartedTask = (queryClient: QueryClient, task: Task) => {
  queryClient.setQueryData<Task[]>(taskKeys.mine, (tasks = []) =>
    tasks.some(({ name }) => name === task.name) ? tasks : [task, ...tasks],
  );
  void refreshMyTasks(queryClient);
};
